import React from 'react';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
const items = [{
  title: 'Baraja Sistémica de Constelación Familiar (250 Cartas) + Manual de Aplicación',
  description: 'Set de 250 cartas terapéuticas diseñado para identificar patrones familiares invisibles, comprender bloqueos emocionales y facilitar movimientos de sanación, acompañado de un manual práctico para usar desde la primera sesión.',
  image: 'https://cdn.magicpatterns.com/uploads/vPpVN3RWPTwoBHjt2fnkyY/Diseno_sin_titulo_(7)_(4).webp'
}, {
  title: 'Diario Terapéutico de Integración Sistémica',
  description: 'Cuaderno de acompañamiento para que el consultante registre emociones, descubrimientos, reflexiones y cambios internos luego de cada sesión de Constelación Familiar.',
  image: 'https://cdn.magicpatterns.com/uploads/nemGPti3XNmzZzn19RwNFf/Diseno_sin_titulo_(8).webp'
}, {
  title: 'Guía Práctica de Resolución de Conflictos Familiares',
  description: 'Métodos simples y efectivos para ayudar al terapeuta a abordar tensiones familiares con mayor claridad, armonía y reconciliación emocional.',
  image: 'https://cdn.magicpatterns.com/uploads/wh6xha6LKUkSFKsMyq2PfW/Diseno_sin_titulo_(9).webp'
}, {
  title: 'Constelación Sistémica de la Prosperidad + Oráculo de Abundancia Familiar (50 Cartas)',
  description: 'Herramienta terapéutica orientada a liberar bloqueos heredados relacionados con dinero, merecimiento y prosperidad, conectando linaje familiar y abundancia.',
  image: 'https://cdn.magicpatterns.com/uploads/hErsPFLcZFZ9rAeAVmK1mJ/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil.webp'
}, {
  title: 'Fichas Profesionales de Anamnesis Sistémica (Constelación + Genograma) – Editables en Canva',
  description: 'Plantillas profesionales personalizables para registrar historia familiar, vínculos emocionales, repeticiones generacionales y dinámicas sistémicas con orden visual.',
  image: 'https://cdn.magicpatterns.com/uploads/u5cPSUTk39hQ5d2kyRPU9K/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil_(1).webp'
}, {
  title: 'Guía Visual de Genograma Terapéutico + Cartas de Afirmaciones Sistémicas Sanadoras',
  description: 'Manual paso a paso para crear genogramas familiares en consulta y detectar patrones ocultos, acompañado de cartas con afirmaciones restauradoras.',
  image: 'https://cdn.magicpatterns.com/uploads/8GSveiomGzQ3kXkuhcVpma/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil_(2).webp'
}, {
  title: 'Gestalt Sistémica en Sesión – 350 Preguntas Terapéuticas',
  description: 'Colección de preguntas profundas para expandir la conciencia del cliente, desbloquear emociones reprimidas y revelar movimientos inconscientes del sistema familiar.',
  image: 'https://cdn.magicpatterns.com/uploads/ceotCNu32jicTK8AHBhkmr/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil_(3).webp'
}, {
  title: 'Guion Profesional de Sesión de Constelación Familiar',
  description: 'Estructura completa de sesión que guía desde la apertura del campo sistémico hasta el cierre emocional e integración final del proceso.',
  image: 'https://cdn.magicpatterns.com/uploads/oUhjGv3YFmhN7pBXksPDo9/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil_(4).webp'
}, {
  title: 'Checklist de Preparación Energética del Constelador',
  description: 'Lista práctica para prepararte antes de cada sesión con ejercicios de respiración, intención, limpieza energética y enfoque terapéutico.',
  image: 'https://cdn.magicpatterns.com/uploads/kufUnrk4PcccSFstHYpqm7/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil_(5).webp'
}, {
  title: 'Planilla de Seguimiento Terapéutico del Cliente',
  description: 'Sistema organizado para registrar avances, sesiones realizadas, evolución emocional y resultados visibles de cada proceso terapéutico.',
  image: 'https://cdn.magicpatterns.com/uploads/dMyZFz2hbqbVbdXHLuwzfP/Kit_avanzado_para_trabajar_las_raices_emocionales,_liberar_patrones_familiares_y_promover_la_reconexion_y_el_equilibrio_profundo._Este_producto_es_para_facilitar_el_proceso_de_Constelaciones_Famil_(6).webp'
}];
export function WhatYouReceive() {
  return <section className="py-24 bg-white pt-[30px] pb-[30px]" data-id="element-298">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none opacity-50" data-id="element-299" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-sky-50 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2 pointer-events-none opacity-50" data-id="element-300" />

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-301">
        <div className="text-center mb-16" data-id="element-302">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-blue-100 text-blue-600 text-xs font-black uppercase tracking-widest mb-6" data-id="element-303">
            <Sparkles size={14} data-id="element-304" />
            <span data-id="element-305">Tu Transformación Profesional</span>
          </motion.div>

          <h2 className="md:text-5xl text-blue-950 uppercase italic text-[20px] font-[700] font-[Inter,_sans-serif]" data-id="element-306">
            Aquí está todo lo que recibís <br className="hidden md:block" data-id="element-307" />
            <span className="text-blue-600" data-id="element-308">al acceder hoy</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-309">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group p-6 rounded-3xl bg-blue-50/50 border border-blue-100 hover:bg-white hover:shadow-xl hover:shadow-blue-200/30 transition-all duration-300" data-id="element-310">
              {item.image && <div className="mb-6 overflow-hidden rounded-2xl" data-id="element-311">
                  <img src={item.image} alt={item.title} className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-312" />
                </div>}
              <div className="flex items-start gap-4" data-id="element-313">
                <div className="shrink-0 mt-1" data-id="element-314">
                  <CheckCircle2 className="text-blue-600 group-hover:scale-110 transition-transform" size={24} data-id="element-315" />
                </div>
                <div data-id="element-316">
                  <h3 className="text-lg font-bold text-blue-950 mb-2 leading-tight" data-id="element-317">
                    {item.title}
                  </h3>
                  <p className="text-blue-800/70 text-sm leading-relaxed" data-id="element-318">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-16 p-8 rounded-[2.5rem] bg-gradient-to-br from-blue-600 to-blue-800 text-white text-center shadow-2xl shadow-blue-200" data-id="element-319">
          <p className="text-xl md:text-2xl font-medium italic" data-id="element-320">
            "No es solo una guía, es el mapa sistémico para ordenar tu historia
            y potenciar tu mirada como facilitador profesional."
          </p>
        </div>
      </div>
    </section>;
}